module.exports = __webpack_public_path__ + "static/media/mastodon-logo-black.6040d836.svg";